import { AxiosResponse }         from "axios";
import { oc }                    from "ts-optchain";
import { DealernetApi }          from "./DealernetApi";
import { INewsStoryDto, 
    INewsFilterDto, 
    INewsCategoryStoryCountDto } from "@/types";

export class NewsService {
    public static async getNewsStoryById(id: number | string): Promise<INewsStoryDto[]> {
        const response = await DealernetApi.client().request({
            method: "get",
            url: `News/GetNewsStoryById?id=${id}`,
        });
        const data = oc(response as AxiosResponse<INewsStoryDto[]>).data([]);
        return data;
    }
    public static async getHomePageNewsStories(): Promise<INewsStoryDto[]> {
        const response = await DealernetApi.client().request({
            method: "get",
            url: "News/GetHomePageNewsStories",
        });
        const data = oc(response as AxiosResponse<INewsStoryDto[]>).data([]);
        return data;
    }
    public static async getAllActiveNewsStories(): Promise<INewsStoryDto[]> {
        const response = await DealernetApi.client().request({
            method: "get",
            url: "News/GetAllActiveNewsStories",
        });
        const data = oc(response as AxiosResponse<INewsStoryDto[]>).data([]);
        return data;
    }
    public static async getNewsCategoryStoryCount(brandAuth: number, regionAuth: number): Promise<INewsCategoryStoryCountDto[]> {
        const response = await DealernetApi.client().request({
            method: "get",
            url: `News/GetNewsCategoryStoryCount?brandAuth=${brandAuth}&regionAuth=${regionAuth}`,
        });
        const data = oc(response as AxiosResponse<INewsCategoryStoryCountDto[]>).data([]);
        return data;
    }
    public static async getNewsStoriesByCategoryId(categoryId: number): Promise<INewsStoryDto[]> {
        const response = await DealernetApi.client().request({
            method: "get",
            url: `News/GetNewsStoriesByCategoryId?id=${categoryId}`,
        });
        const data = oc(response as AxiosResponse<INewsStoryDto[]>).data([]);
        return data;
    }
}
